import React from "react";
import { useState } from "react";

// Kainininkas pozicijų pasirinkimas: kainininkas (tiekėjas) → gamintojas → medžiaga
export function KaininkasPositionSelect({ allKainininkai, onSelect }) {
  const [selKain, setSelKain] = useState('');
  const [selGamin, setSelGamin] = useState('');
  const [selItem, setSelItemLocal] = useState('');

  // Kainininkas = tiekėjas
  const kainininkai = allKainininkai || [];

  // Gamintojai iš pasirinkto kainininko
  const gamintojaiSet = new Set();
  const curKain = kainininkai.find(k => String(k.id) === selKain);
  if (curKain) {
    (curKain.groups||[]).forEach(g => {
      (g.items||[]).forEach(it => {
        if (it.gamintojas && it.gamintojas.trim()) gamintojaiSet.add(it.gamintojas.trim());
      });
    });
  }
  const gamintojai = [...gamintojaiSet].sort();

  // Jei gamintojas pasirinktas - filtruojame medžiagas pagal gamintoją
  // Jei ne - rodome visas
  const allItems = [];
  if (curKain) {
    (curKain.groups||[]).forEach(g => {
      (g.items||[]).forEach(it => {
        if (!selGamin || it.gamintojas === selGamin) {
          allItems.push({...it, groupName: g.name, groupId: g.id});
        }
      });
    });
  }

  return (
    <div style={{background:'#f8f9fb',border:'1px dashed #d1d5db',borderRadius:7,padding:'8px',marginBottom:6}}>
      <div style={{fontSize:10,fontWeight:700,color:'#374151',marginBottom:6}}>Pasirinkti iš kainininko</div>
      <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
        {/* Tiekėjas (kainininkas) */}
        <select value={selKain} onChange={e=>{setSelKain(e.target.value);setSelGamin('');setSelItemLocal('');}}
          style={{flex:1,minWidth:120,border:'1px solid #e5e7eb',borderRadius:5,padding:'4px 6px',fontSize:11,boxSizing:'border-box'}}>
          <option value="">— Tiekėjas —</option>
          {kainininkai.map(k=><option key={k.id} value={k.id}>{k.name}</option>)}
        </select>
        {/* Gamintojas */}
        <select value={selGamin} onChange={e=>{setSelGamin(e.target.value);setSelItemLocal('');}} disabled={!selKain}
          style={{flex:1,minWidth:120,border:'1px solid #e5e7eb',borderRadius:5,padding:'4px 6px',fontSize:11,boxSizing:'border-box',background:selKain?'#fff':'#f9fafb'}}>
          <option value="">— Visi gamintojai —</option>
          {gamintojai.map(g=><option key={g} value={g}>{g}</option>)}
        </select>
        {/* Medžiaga */}
        <select value={selItem} onChange={e=>{
          setSelItemLocal(e.target.value);
          const it = allItems.find(x=>String(x.id)===e.target.value);
          if(it && onSelect) onSelect(it);
        }} disabled={!selKain}
          style={{flex:2,minWidth:160,border:'1px solid #e5e7eb',borderRadius:5,padding:'4px 6px',fontSize:11,boxSizing:'border-box',background:selKain?'#fff':'#f9fafb'}}>
          <option value="">— Medžiaga —</option>
          {allItems.map(it=><option key={it.id} value={it.id}>{it.name}{it.gamintojas?' ('+it.gamintojas+')':''} - {it.unit}</option>)}
        </select>
      </div>
    </div>
  );
}
